let workerInstance: Worker | null = null;
let workerReferenceCount = 0;
let workerPromise: Promise<Worker> | null = null;
type WorkerConstructorType = new () => Worker;

const createWorkerAsync = async () => {
  const { default: TableQueryWorker } = await import('./tableQuery.worker');
  const WorkerConstructor = TableQueryWorker as unknown as WorkerConstructorType;
  workerInstance = new WorkerConstructor();
  return workerInstance;
};
export const getTableWorkerInstance = (): Promise<Worker> => {
  workerReferenceCount += 1;

  if (!workerPromise) {
    workerPromise = createWorkerAsync();
  }
  return workerPromise;
};

export function releaseTableWorkerInstance(): void {
  if (workerReferenceCount > 0) {
    workerReferenceCount -= 1;
  }

  if (workerReferenceCount === 0 && workerInstance && typeof workerInstance.terminate === 'function') {
    try {
      workerInstance.terminate();
    } catch (error) {
      console.error('Failed to terminate worker:', error);
    }
    workerInstance = null;
    workerPromise = null;
  }
}
